'use client';

import classNames from 'classnames';
import { ServicesTilesComponent } from '@sapientpro/sapientpro-data-models';
import { useEffect } from 'react';
import { useAtomValue } from 'jotai';
import styles from './DevelopmentServicesSection.module.scss';
import AnimatedTitle from '../AnimatedTitle';
import { Theme, theme } from '../../store/theme';
import DevelopmentServicesCard from './DevelopmentServicesCard';

type DevelopmentServicesSectionProps = {
  data: ServicesTilesComponent;
};

const DevelopmentServicesSection = ({ data }: DevelopmentServicesSectionProps) => {
  const currentTheme = useAtomValue(theme);

  useEffect(() => {
    const setEqualTitleHeights = () => {
      const titles = document.querySelectorAll<HTMLElement>('.developmentServicesSection__cardsTitle');
      let maxHeight = 0;

      titles.forEach(el => {
        el.style.height = 'auto';
      });

      titles.forEach(el => {
        const height = el.offsetHeight;
        if (height > maxHeight) maxHeight = height;
      });

      titles.forEach(el => {
        el.style.height = `${maxHeight}px`;
      });
    };

    setEqualTitleHeights();

    window.addEventListener('resize', setEqualTitleHeights);

    return () => {
      window.removeEventListener('resize', setEqualTitleHeights);
    };
  }, []);

  return (
    <section className={classNames(styles.developmentServicesSection, 'container')}>
      <div className={styles.serviceSectionHead}>
        <h2 className={classNames(styles.developmentServicesSection__title, 'header2')}>
          <AnimatedTitle title={data.title} />
        </h2>
        {data.description && <p className={classNames(styles.description, 'bodyLarge')}>{data.description}</p>}
      </div>
      <div className={classNames(styles.developmentServicesSection__cards, {
        [styles.developmentServicesSection__cards_moreThanFour]: data.items.length > 4,
      })}
      >
        {data.items.map(item => {
          const darkIcon = item?.darkImage?.url || item?.image?.url;
          const lightIcon = item?.image?.url || item?.darkImage?.url;
          const icon = currentTheme === Theme.DARK ? darkIcon : lightIcon;

          return (
            <DevelopmentServicesCard
              key={item.id}
              icon={icon || ''}
              title={item.title}
              description={item.description}
              service={item.service}
              subService={item.sub_service}
              titleClassName='developmentServicesSection__cardsTitle'
            />
          );
        })}
      </div>
    </section>
  );
};

export default DevelopmentServicesSection;
